import { HisSearchResultRow } from 'hisng';
import { AbstractDetailViewListEntry, SimpleLinkDefinition, RowLabels } from './abstract-detail-view-list-entry';
import { DetailViewListUtils } from './detail-view-list-utils';


export class PrizeNominationDetailViewListEntry extends AbstractDetailViewListEntry {

    rowLabels: RowLabels = {
        category: 'fs.res.prizeNomination.Prize.prizeCategory',
        type: 'fs.res.prizeNomination.Prize.prizeType',
        title: 'fs.res.prizeNomination.Prize.title',
        awardingOrganizations: 'fs.res.prizeNomination.Prize.awardingOrganization',
        nominationYear: 'fs.res.prizeNomination.Nomination.nominationYear'
    };

    getOverSearchResultLink(): SimpleLinkDefinition {
        return null;
    }

    getSubheading(row: HisSearchResultRow, data: any, index: number): string {
        return null;
    }

    getHeaderLine(row: HisSearchResultRow): string {
        return `${DetailViewListUtils.capitalizeFirstLetter(DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['category']))} | ` +
            DetailViewListUtils.capitalizeFirstLetter(DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['type']));
    }

    getTitleLine(row: HisSearchResultRow): string {
        return DetailViewListUtils.getRowByLabelKey(row, this.rowLabels.title);
    }

    getToolTip(row: HisSearchResultRow): string {
        return DetailViewListUtils.assembleToolTip(this.getHeaderLine(row).split(' |')[0],
            DetailViewListUtils.getRowByLabelKey(row, this.rowLabels.title), this.hisBaseGlobalsService, this.hisUiService);
    }

    getTitleLink(row: HisSearchResultRow): string {
        return null;
    }

    getExtendableLine(row: HisSearchResultRow, i: number, first: number, rowsPerPage: number): string {
        const allOrgNames = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['awardingOrganizations']);
        const allOrgNamesSplit = allOrgNames ? allOrgNames.split(', ') : [];
        const firstOrgNames = `${allOrgNamesSplit[0]}, ${allOrgNamesSplit[1]}, ${allOrgNamesSplit[2]} et al.`;
        const textPrefix = this.hisUiService.translate('fs.res.prizeNomination.Prize.awardingOrganization') + ': ';
        let text;

        if (allOrgNamesSplit.length === 0) {
            text = '';
        } else if (allOrgNamesSplit.length <= 3 || this.personDetailViewSearchResultComponent.isShowExtendableLine(i, first, rowsPerPage)) {
            text = textPrefix + allOrgNames;
        } else {
            text = textPrefix + firstOrgNames;
        }
        return text;
    }

    getExtendableLineSecond(row: HisSearchResultRow, i: number, first: number, rowsPerPage: number): string {
        return null;
    }

    isExtendable(row: HisSearchResultRow): boolean {
        const allOrgNames = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['awardingOrganizations']);
        const allOrgNamesSplit = allOrgNames ? allOrgNames.split(', ') : [];
        return allOrgNamesSplit.length > 3;
    }

    isExtendableSecond(row: HisSearchResultRow): boolean {
        return false;
    }

    getFooterLine(row: HisSearchResultRow): string {
        return `${this.hisUiService.translate('fs.res.prizeNomination.Nomination.nominationYear')}: ` +
            DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['nominationYear']);
    }

}
